import React from 'react'
import Address from './SubTab/Address'
import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
const GeneralTab = () => {
    const ApplicableOption = [{ value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },];
    return (
        <>
            <div className="row border-bottom-2 pb-3">
                <div className="col-md-3">
                    <div className="custom-card">
                        <div className="branch-bg">
                            <h4 className="mb-0">
                                Branches
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="col-md-9">
                    <div className="card px-3 py-2">
                        <Accordion defaultActiveKey="0" className="accordion-item rounded mb-3" >
                            <Accordion.Item eventKey="0">
                                <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark"> <span className="avatar avatar-md rounded text-dark border me-2">
                                    <i className="ti ti-user-plus fs-20" />
                                </span>
                                    General Information</Accordion.Header>
                                <Accordion.Body>
                                    <form>
                                        <div className="row">
                                            <div className="col-8">
                                                <div className="mb-3">
                                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                            Name
                                                        </label>

                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        id="name"
                                                        name="name"
                                                        placeholder='Enter Branch Name'
                                                    // onChange={formik.handleChange}
                                                    // onBlur={formik.handleBlur}
                                                    // value={formik.values.name}
                                                    />
                                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="mb-3">
                                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                            Alies
                                                        </label>

                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        id="name"
                                                        name="name"
                                                        placeholder='Enter Branch Name'
                                                    // onChange={formik.handleChange}
                                                    // onBlur={formik.handleBlur}
                                                    // value={formik.values.name}
                                                    />
                                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="mb-3">
                                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                            Branch Name
                                                        </label>
                                                        <div className="mb-0 form-check">
                                                            <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                                            <label className="form-label mb-0" htmlFor="exampleCheck1">
                                                                Set as Default
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        id="name"
                                                        name="name"
                                                        placeholder='Enter Branch Name'
                                                    // onChange={formik.handleChange}
                                                    // onBlur={formik.handleBlur}
                                                    // value={formik.values.name}
                                                    />
                                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="mb-3">
                                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                            Address
                                                        </label>
                                                        <div className="mb-0 form-check">
                                                            <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                                            <label className="form-label mb-0" htmlFor="exampleCheck1">
                                                                Deactivate
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="mb-1">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            id="name"
                                                            name="name"
                                                            placeholder='Enter Address'
                                                        // onChange={formik.handleChange}
                                                        // onBlur={formik.handleBlur}
                                                        // value={formik.values.name}
                                                        />
                                                        {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                                    </div>
                                                    <div className="mb-1">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            id="name"
                                                            name="name"
                                                            placeholder='Enter Address line 2'
                                                        // onChange={formik.handleChange}
                                                        // onBlur={formik.handleBlur}
                                                        // value={formik.values.name}
                                                        />
                                                        {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                                    </div>
                                                    <div className="mb-1">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            id="name"
                                                            name="name"
                                                            placeholder='Enter Address line 3'
                                                        // onChange={formik.handleChange}
                                                        // onBlur={formik.handleBlur}
                                                        // value={formik.values.name}
                                                        />
                                                        {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                            Country
                                                        </label>

                                                    </div>
                                                    <Select

                                                        className='custom-selector'
                                                        options={ApplicableOption}
                                                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                                    // onBlur={formik.handleBlur}
                                                    />
                                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                            State/Province
                                                        </label>

                                                    </div>
                                                    <Select

                                                        className='custom-selector'
                                                        options={ApplicableOption}
                                                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                                    // onBlur={formik.handleBlur}
                                                    />
                                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                            City
                                                        </label>

                                                    </div>
                                                    <Select

                                                        className='custom-selector'
                                                        options={ApplicableOption}
                                                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                                    // onBlur={formik.handleBlur}
                                                    />
                                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                            Postal Code
                                                        </label>

                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        id="name"
                                                        name="name"
                                                        placeholder='Enter Postal Code'
                                                    // onChange={formik.handleChange}
                                                    // onBlur={formik.handleBlur}
                                                    // value={formik.values.name}
                                                    />
                                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                                </div>
                                            </div>

                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                            Telephone
                                                        </label>

                                                    </div>
                                                    <Select

                                                        className='custom-selector'
                                                        options={ApplicableOption}
                                                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                                    // onBlur={formik.handleBlur}
                                                    />
                                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                            Fax
                                                        </label>

                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        id="name"
                                                        name="name"
                                                        placeholder='Enter Postal Code'
                                                    // onChange={formik.handleChange}
                                                    // onBlur={formik.handleBlur}
                                                    // value={formik.values.name}
                                                    />
                                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                                </div>
                                            </div>

                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                            Website
                                                        </label>

                                                    </div>
                                                    <Select
                                                        className='custom-selector'
                                                        options={ApplicableOption}
                                                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                                    // onBlur={formik.handleBlur}
                                                    />
                                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                            Email Address
                                                        </label>

                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        id="name"
                                                        name="name"
                                                        placeholder='Enter Postal Code'
                                                    // onChange={formik.handleChange}
                                                    // onBlur={formik.handleBlur}
                                                    // value={formik.values.name}
                                                    />
                                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                                </div>
                                            </div>


                                        </div>
                                        {/* <div className="row">
                                            <div className="col-12">
                                                <div className="loading-port-text">
                                                    Default Loading / Discharge Port
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                            For Sea
                                                        </label>

                                                    </div>
                                                    <Select
                                                        className='custom-selector'
                                                        options={ApplicableOption}
                                                
                                                    />
                                            
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                            State/Province
                                                        </label>

                                                    </div>
                                                    <Select

                                                        className='custom-selector'
                                                        options={ApplicableOption}
                                                  
                                                    />
                                              
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex flex-wrap gap-2">
                                                <div className="port-btn w-fit cursor-pointer">
                                                    new
                                                </div>
                                                <div className="port-btn w-fit cursor-pointer">
                                                    Update
                                                </div>
                                                <div className="port-btn w-fit cursor-pointer">
                                                    Delete
                                                </div>
                                            </div>
                                            <div className="cursor-pointer add-branch">
                                                + Add Branch
                                            </div>
                                        </div>


                                    </form>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>

                    </div>
                </div>
            </div>
            <div className="row justify-content-end mt-3 gap-2">
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Save
                </button>
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Save & Close
                </button>
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Save & New
                </button>
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Close
                </button>

            </div>
        </>
    )
}

export default GeneralTab